// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinerLoader_loader__2iz2V"};